module.exports = __webpack_public_path__ + "static/media/it-consultancy.e93560e6.svg";